var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseNewCardDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00802 12.9004V8.89048C2.00802 8.22483 2.54535 7.6875 3.211 7.6875H23.2607C23.9264 7.6875 24.4637 8.22483 24.4637 8.89048V12.9004M2.00802 12.9004H24.4637M4.95132 15.8036H7.56581M10.6214 15.8036H11.6399M2 12.9004V21.7223C2 22.388 2.53733 22.9253 3.20298 22.9253H14.0298",
    stroke: "white",
    strokeWidth: 2.01299,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6614 29.4616C27.7142 29.4616 30.9996 26.1761 30.9996 22.1234C30.9996 18.0706 27.7142 14.7852 23.6614 14.7852C19.6087 14.7852 16.3232 18.0706 16.3232 22.1234C16.3232 26.1761 19.6087 29.4616 23.6614 29.4616Z",
    fill: "#00A3A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6543 18.6104V25.6438",
    stroke: "white",
    strokeWidth: 2.01299,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1406 22.123H27.1741",
    stroke: "white",
    strokeWidth: 2.01299,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseNewCardDark);
export default __webpack_public_path__ + "static/media/UseNewCardDark.fa0e60129f74d8ee545cb34d462906b1.svg";
export { ForwardRef as ReactComponent };